import { createFeatureSelector } from '@ngrx/store';
import { IPlutoState } from '@stores/pluto.reducer';

export const selectPluto = createFeatureSelector<IPlutoState>('pluto');
